import React from "react"

import { Helmet } from "react-helmet"

import * as ReactDOMServer from "react-dom/server"

interface IFaq {
  FaqItem?: JSX.Element[][]
}

export const Faq = ({ FaqItem }: IFaq) => (
  <Helmet>
    <script type="application/ld+json">
      {JSON.stringify([
        {
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: FaqItem?.map(([question, answer]: JSX.Element[]) => ({
            "@type": "Question",
            name: ReactDOMServer.renderToString(question),
            acceptedAnswer: {
              "@type": "Answer",
              text: ReactDOMServer.renderToString(answer),
            },
          })),
        },
      ])}
    </script>
  </Helmet>
)
